import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Button,
  Switch,
} from "@mui/material";

import { Row, Col, FormGroup, Alert, Label } from "reactstrap";
import { AvForm, AvField, AvGroup } from "availity-reactstrap-validation";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import TextField from "@mui/material/TextField";

import {
  getOrgAccounts,
  clearAllOrgAcctMessages,
} from "../../../store/actions";

import spinner from "../../../assets/images/loadingGif.gif";
import { 
  createOrgBillingUsage,
  getOrgBillingUsage,
  clearAllOrgBillingUsageMessages 
} from "../../../store/organizationBillingUsage/organizationBillingUsageSlice";

import { makeStyles } from "@mui/styles";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { commonStyles } from '../../../theme';

const useStyles = makeStyles((theme) => ({
  ...commonStyles,
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflowY: "auto",
    maxHeight: "100vh",
  },
}));

const createOrgBillingUsageEmptyFormState = {
  accountNumber: "",
  dateFrom: "",
  dateTo: "",
  proratedDays: "",
  contractAmount: "",
  additionalAmount: "",
  thresholdAmount: "",
  usagePercentage: "",
};

const convertArrayToDateObj = (dateArray) => {
  const dateString = dateArray[1]+"/"+dateArray[2]+"/"+dateArray[0];
  // console.log("dateString: ", dateString);
  return new Date(dateString);
} 

const OrganizationBillingUsage = (props) => {
  console.log("OrganizationBillingUsage props: ", props);
  console.log("Props, billingUsage: ", props.billingUsage);
  const classes = useStyles();
  const { 
    open,
    onClose,
    orgCode
  } = props;

  const [createOrgBillingUsageFormState, setCreateOrgBillingUsageFormState] = useState(createOrgBillingUsageEmptyFormState);

  const isCreateOrgBillingUsageFormInvalid = () => { 
    const isInvalidItems = [
      {
        field: "dateFrom",
        isInvalid: createOrgBillingUsageFormState.dateFrom === "" ? true : false,
      },
      {
        field: "dateTo",
        isInvalid: createOrgBillingUsageFormState.dateTo === "" ? true : false,
      },
      {
        field: "proratedDays",
        isInvalid: createOrgBillingUsageFormState.proratedDays === "" ? true : false,
      },
      {
        field: "contractAmount",
        isInvalid: createOrgBillingUsageFormState.contractAmount === "" ? true : false,
      },
      {
        field: "additionalAmount",
        isInvalid: createOrgBillingUsageFormState.additionalAmount === "" ? true : false,
      },
      {
        field: "thresholdAmount",
        isInvalid: createOrgBillingUsageFormState.thresholdAmount === "" ? true : false,
      },
      {
        field: "usagePercentage",
        isInvalid: createOrgBillingUsageFormState.usagePercentage === "" ? true : false,
      },
    ];

    // console.log("isInvalidItems: ", isInvalidItems);

    return isInvalidItems?.filter((item) => item.isInvalid)?.length > 0;
  }

  const handleCreateOrgBillingUsage = (e) => {
    const createOrgBillingUsagePayload = createOrgBillingUsageFormState;

    console.log("createOrgBillingUsagePayload : ", createOrgBillingUsagePayload);

    // Make API Call
    props.createOrgBillingUsage(createOrgBillingUsagePayload);
  };


  const clearCreateFormState = () => {
    setCreateOrgBillingUsageFormState(createOrgBillingUsageEmptyFormState);
  };

  useEffect(() => {
    props.getOrgAccounts(orgCode);
  }, [orgCode]);

  useEffect(() => {
    if (props.orgAccounts && props.orgAccounts?.length > 0) {
      setCreateOrgBillingUsageFormState({
        ...createOrgBillingUsageFormState, "accountNumber": props.orgAccounts[0].accountNumber
      });
    }    
  }, [props.orgAccounts]);

  // For displaying message for creating organization billing usage
  let createOrgBillingUsageMessage = props.createOrgBillingUsageMessage;
  useEffect(() => {
    console.log("createOrgBillingUsageMessage = " + createOrgBillingUsageMessage);
    if (createOrgBillingUsageMessage) {
      console.log(
        "Inside if, createOrgBillingUsageMessage = " + createOrgBillingUsageMessage
      );
      props.onClose();
      //Clear state variables associated with the form
      clearCreateFormState();
    }
  }, [createOrgBillingUsageMessage]);

  const accountNumber = createOrgBillingUsageFormState.accountNumber;
  useEffect(() => {
    console.log("useEffect, accountNumber = " + accountNumber);
    if (accountNumber) {
      props.getOrgBillingUsage(accountNumber);
    }
  }, [accountNumber]);

  const billingUsage = props.billingUsage;
  useEffect(() => {
    console.log("useEffect, billingUsage = " + billingUsage);
    if (billingUsage) {
      setCreateOrgBillingUsageFormState({
        ...createOrgBillingUsageFormState,
        additionalAmount: billingUsage.additionalAmount,
        contractAmount: billingUsage.contractAmount,
        proratedDays: billingUsage.proratedDays,
        thresholdAmount: billingUsage.thresholdAmount,
        usagePercentage: billingUsage.usagePercentage,
        dateFrom: convertArrayToDateObj(billingUsage.dateFrom),
        dateTo: convertArrayToDateObj(billingUsage.dateTo),
      });
    }
  }, [billingUsage]);


  return (
    <Modal className={classes.modal} open={open} onClose={onClose} disableAutoFocus disableEnforceFocus>
      <div className={classes.paper} style={{ height: "600px" }}>
        <h3>Create Organization Billing Usage</h3>
        {props.isCreatingOrgBillingUsage && (
          <div style={{ display: "flex", alignContent: "center", justifyContent: "center" }}>
            <img src={spinner} width="32px" alt="Spinner" />
          </div>
        )}
        {/* Error message */}
        {props.createOrgBillingUsageError && (
          <Alert className="mt-3 mb-0" color="danger">
            Error while creating organization billing usage. {JSON.stringify(props.createOrgBillingUsageError?.message)}
          </Alert>
        )}
        <AvForm>
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            <Row>
              <Col lg="12">
                <FormGroup>
                    <Label for="accountNumber">Account Number</Label>
                    {props.isGettingOrgAccounts || props.isGettingOrgBillingUsage
                      ? (
                          <div style={{ display: "flex", alignContent: "center", justifyContent: "center" }}>
                            <img src={spinner} width="32px" alt="Spinner" />
                          </div>
                      )
                      : (
                          <AvField
                            type="select"
                            name="accountNumber"
                            value={createOrgBillingUsageFormState.accountNumber}
                            onChange={(e) => setCreateOrgBillingUsageFormState({...createOrgBillingUsageFormState, accountNumber:e.target.value})}
                            id="accountNumber"
                          >
                            {props?.orgAccounts?.map((account) => (
                                <option key={account.accountNumber} value={account.accountNumber}>
                                  {account.accountNumber} - {account.accountName}
                                </option>
                            ))}
                          </AvField>
                        )
                    }
                    
                  </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col lg="6">
                <FormGroup>
                    <Label for="dateFrom">Date From</Label>
                    <DatePicker
                      selected={createOrgBillingUsageFormState.dateFrom ? new Date(createOrgBillingUsageFormState.dateFrom) : null}
                      onChange={(date) => setCreateOrgBillingUsageFormState({
                        ...createOrgBillingUsageFormState,
                        dateFrom: date
                      })}
                      className="form-control"
                      dateFormat="MM/dd/yyyy"
                      placeholderText="Select start date"
                    />
                </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup>
                  <Label for="dateTo">Date To</Label>
                  <DatePicker
                    selected={createOrgBillingUsageFormState.dateTo ? new Date(createOrgBillingUsageFormState.dateTo) : null}
                    onChange={(date) => setCreateOrgBillingUsageFormState({
                      ...createOrgBillingUsageFormState,
                      dateTo: date
                    })}
                    className="form-control"
                    dateFormat="MM/dd/yyyy"
                    placeholderText="Select end date"
                    minDate={createOrgBillingUsageFormState.dateFrom ? new Date(createOrgBillingUsageFormState.dateFrom) : null}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col lg="6">
                <FormGroup>
                  <Label for="proratedDays">Prorated Days</Label>
                  <AvField
                    name="proratedDays"
                    value={createOrgBillingUsageFormState.proratedDays}
                    onChange={(e) => setCreateOrgBillingUsageFormState({...createOrgBillingUsageFormState, proratedDays:e.target.value})}
                    type="number"
                    errorMessage="Enter prorated Days"
                    validate={{
                      required: {value: true},
                    }}
                    id="proratedDays"
                    placeholder="Prorated Days"
                  />
                </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup>
                  <Label for="contractAmount">Contract Amount</Label>
                  <AvField
                    name="contractAmount"
                    value={createOrgBillingUsageFormState.contractAmount}
                    onChange={(e) => setCreateOrgBillingUsageFormState({...createOrgBillingUsageFormState, contractAmount:e.target.value})}
                    type="number"
                    errorMessage="Enter Contract Amount"
                    validate={{
                      required: {value: true},
                    }}
                    id="contractAmount"
                    placeholder="Contract Amount"
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col lg="6">
                <FormGroup>
                  <Label for="additionalAmount">Additional Amount</Label>
                  <AvField
                    name="additionalAmount"
                    value={createOrgBillingUsageFormState.additionalAmount}
                    onChange={(e) => setCreateOrgBillingUsageFormState({...createOrgBillingUsageFormState, additionalAmount:e.target.value})}
                    type="number"
                    errorMessage="Enter Additional Amount"
                    validate={{
                      required: {value: true},
                    }}
                    id="additionalAmount"
                    placeholder="Additional Amount"
                  />
                </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup>
                  <Label for="thresholdAmount">Threshold Amount</Label>
                  <AvField
                    name="thresholdAmount"
                    value={createOrgBillingUsageFormState.thresholdAmount}
                    onChange={(e) => setCreateOrgBillingUsageFormState({...createOrgBillingUsageFormState, thresholdAmount:e.target.value})}
                    type="number"
                    errorMessage="Enter Threshold Amount"
                    validate={{
                      required: {value: true},
                    }}
                    id="thresholdAmount"
                    placeholder="Threshold Amount"
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col lg="6">
                <FormGroup>
                  <Label for="usagePercentage">Usage Percentage</Label>
                  <AvField
                    name="usagePercentage"
                    value={createOrgBillingUsageFormState.usagePercentage}
                    onChange={(e) => setCreateOrgBillingUsageFormState({...createOrgBillingUsageFormState, usagePercentage:e.target.value})}
                    type="number"
                    errorMessage="Enter Usage Percentage"
                    validate={{
                      required: {value: true},
                    }}
                    id="usagePercentage"
                    placeholder="Usage Percentage"
                  />
                </FormGroup>
              </Col>
            </Row>

            <Button
              color="primary"
              variant="contained"
              disabled={isCreateOrgBillingUsageFormInvalid() || props.isCreatingOrgBillingUsage}
              onClick={handleCreateOrgBillingUsage}
            >
              Create Billing Usage Record
            </Button>
          </div>
        </AvForm>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  const {
    orgAccounts,
    // orgUsers,
    // organization,

    isGettingOrgAccounts,
    getOrgAccountsError,
    getOrgAccountsMessage,

  } = state.orgAccount;

  const {
    isCreatingOrgBillingUsage,
    createOrgBillingUsageMessage,
    createOrgBillingUsageError,

    billingUsage,
    isGettingOrgBillingUsage,
    getOrgBillingUsageMessage,
    getOrgBillingUsageError
  } = state.organizationBillingUsageSlice;

  return {
    orgAccounts,
    isGettingOrgAccounts,
    getOrgAccountsError,
    getOrgAccountsMessage,

    isCreatingOrgBillingUsage,
    createOrgBillingUsageMessage,
    createOrgBillingUsageError,

    billingUsage,
    isGettingOrgBillingUsage,
    getOrgBillingUsageMessage,
    getOrgBillingUsageError
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getOrgAccounts: (orgCode) => {
      dispatch(getOrgAccounts(orgCode));
    },
    clearAllOrgAcctMessages: () => {
      dispatch(clearAllOrgAcctMessages());
    },
    createOrgBillingUsage: (createOrgBillingUsagePayload) => {
      dispatch(createOrgBillingUsage(createOrgBillingUsagePayload));
    },
    getOrgBillingUsage: (accnumber) => {
      dispatch(getOrgBillingUsage(accnumber));
    },
    clearAllOrgBillingUsageMessages: () => {
      dispatch(clearAllOrgBillingUsageMessages());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationBillingUsage);
